import React from 'react';
type PageHeaderProps = {
  label: string;
  title: string;
  intro: string;
};
export function PageHeader({
  label,
  title,
  intro
}: PageHeaderProps) {
  return <section className="border-b border-hairline bg-ivory" data-id="element-113" data-mp="3cjfu6uxd9dxj">
      <div className="mx-auto max-w-7xl px-6 pb-16 pt-16 lg:px-8 lg:pb-20 lg:pt-24" data-id="element-114" data-mp="3rdauvdndbwxn">
        <p className="flex items-center gap-3 text-sm font-medium text-steel" data-id="element-115" data-mp="3mf992kyk5jih">
          <span className="h-px w-10 bg-gold" aria-hidden="true" data-id="element-116" data-mp="2ypopbzukyi85" />
          {label}
        </p>
        <h1 className="mt-6 max-w-4xl font-serif text-4xl leading-[1.1] text-navy sm:text-5xl lg:text-[3.4rem]" data-id="element-117" data-mp="2tr3rg72swamv">
          {title}
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-steel" data-id="element-118" data-mp="38hayzrr9s98s">{intro}</p>
      </div>
    </section>;
}